export const labels = {
  CHOOSE_COVER_IMAGE: 'Choose Cover Image',
  COVER_IMAGE: 'Cover Image',
  SELECT_FROM_COMPUTER: 'Select Image From Computer',
  CANCEL: 'Cancel',
  UPLOAD: 'Upload'
};
